import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Loader2, Lock, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { BRAND } from "@/lib/brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user !== false) navigate("/admin");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success("Bem-vindo!");
      navigate("/admin");
    } else {
      toast.error(res.error || "Falha no login.");
    }
  };

  return (
    <div className="min-h-screen bg-efory-ink text-white flex items-center justify-center px-6 relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-dark opacity-40" />
      <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-efory-blue/20 blur-[120px]" />

      <div className="relative w-full max-w-md">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Voltar ao site
        </Link>

        <div className="rounded-3xl border border-white/10 bg-white/[0.04] backdrop-blur-md p-8">
          <div className="flex flex-col items-center text-center mb-8">
            <img src={BRAND.logo} alt="EFORY" className="h-14 w-14 object-contain rounded-xl" />
            <h1 className="font-heading text-2xl font-bold mt-4 flex items-center gap-2">
              <Lock className="h-5 w-5 text-efory-blue" /> Área restrita
            </h1>
            <p className="text-white/55 text-sm mt-1.5">Acesse o painel de contatos da EFORY.</p>
          </div>

          <form onSubmit={submit} className="space-y-5" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-white/80 text-sm">E-mail</Label>
              <Input
                id="email"
                type="email"
                data-testid="login-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@efory.com"
                className="mt-2 h-12 bg-white/5 border-white/15 text-white placeholder:text-white/35 focus-visible:ring-efory-blue focus-visible:border-efory-blue"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-white/80 text-sm">Senha</Label>
              <Input
                id="password"
                type="password"
                data-testid="login-password-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="mt-2 h-12 bg-white/5 border-white/15 text-white placeholder:text-white/35 focus-visible:ring-efory-blue focus-visible:border-efory-blue"
              />
            </div>
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full h-12 bg-efory-blue hover:bg-efory-bluedark rounded-full font-semibold text-base transition-all duration-300 hover:scale-[1.02]"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
